import React, { useEffect, useState } from "react";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import { MasterPanel } from "./components/MasterPanel";
import { TrocarSenhaDialog } from "./components/TrocarSenhaDialog";
import { Toaster } from "./components/ui/sonner";
import { Loader2 } from "lucide-react";

function Shell() {
  const { user, loading } = useAuth();
  const [master, setMaster] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.ctrlKey && (e.key === "m" || e.key === "M")) {
        e.preventDefault();
        setMaster(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="app-loading">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) return <Login />;

  if (user.must_change_password) {
    return (
      <div className="min-h-screen grid place-items-center bg-background px-4" data-testid="forcar-troca-senha">
        <div className="text-center max-w-md">
          <p className="text-xs tracking-[0.28em] uppercase text-slate-400">AFS Track</p>
          <h1 className="text-2xl font-semibold font-display mt-2">Primeiro acesso</h1>
          <p className="text-sm text-slate-500 mt-2">
            Para continuar, crie sua senha pessoal de acesso ao sistema.
          </p>
        </div>
        <TrocarSenhaDialog open obrigatorio />
      </div>
    );
  }

  return (
    <>
      <Dashboard onOpenMaster={() => setMaster(true)} />
      <MasterPanel open={master} onOpenChange={setMaster} />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Shell />
      <Toaster position="top-right" />
    </AuthProvider>
  );
}
